import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function DesktopCncSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("desktopCnc.title")}</title>
        <meta name="keywords" content={t("desktopCnc.keywords")} />
        <meta name="description" content={t("desktopCnc.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#3d2e1f]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/cnc-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_14%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#241a10]/92 via-[#241a10]/72 to-[#241a10]/62" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("desktopCnc.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("desktopCnc.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("desktopCnc.knowledgeBase.rootLabel")}
        rootColor="#b45309"
        treeTranslationKey="desktopCnc.knowledgeBase.tree"
        i18nPrefix="desktopCnc.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="desktopCnc"
        images={{
          painPoints: "/solutions/cnc-pain.jpeg",
          solutions: "/solutions/cnc-solutions.jpeg",
          cta: "/solutions/cnc-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 22%",
          solutions: "50% 26%",
          cta: "50% 18%",
        }}
      />
    </>
  );
}
